import React from 'react';  
import { Card, Container, Row, Col } from 'react-bootstrap';  
import { Link } from 'react-router-dom';  
import '../App.css'; // Ensure this imports your main styles  
import './UploadDashboard.css'; // Import your new CSS file  
  
const deviceTypes = [  
  { name: "Mobile Device", icon: "fas fa-mobile-alt" },  
  { name: "Tablet", icon: "fas fa-tablet-alt" },  
  { name: "MacBook", icon: "fas fa-laptop" },  
  { name: "Laptop", icon: "fas fa-laptop" },  
  { name: "TV", icon: "fas fa-tv" },  
];  
  
const UploadDashboard = () => {  
  return (  
    <Container className="upload-dashboard-container">  
      <h1 className="upload-dashboard-title">Choose Your Device Type</h1>  
      <Row className="justify-content-center">  
        {deviceTypes.map((device, index) => (  
          <Col md={4} className="mb-4" key={index}>  
            <Link to={`/upload/${encodeURIComponent(device.name)}`} className="text-decoration-none">  
              <Card className="device-card shadow" style={{ cursor: 'pointer' }}>  
                <Card.Body className="device-card-body">  
                  <i className={`${device.icon} device-icon`} aria-hidden="true"></i>  
                  <Card.Title>{device.name}</Card.Title>  
                </Card.Body>  
              </Card>  
            </Link>  
          </Col>  
        ))}  
      </Row>  
    </Container>  
  );  
};  
  
export default UploadDashboard;